module.exports = __webpack_public_path__ + "static/img/9.da1cb32.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting674/images/9.png
// module id = ysvR
// module chunks = 4